import React from 'react'

import { HeadingXSmall, SettingsIcon, FadeIn, Panel, Label } from '@pb/components'
import PropTypes from 'prop-types'

import runKlarnaOperation from 'helpers/runKlarnaOperation'
import SecondaryAction from 'ui/buttons/SecondaryAction'

import styles from './ManageCard.scss'

const ManageCard: React.FC<any> = ({ manageCardOperation }) => {
  const handleManageCard = (): any => {
    const { token } = manageCardOperation
    runKlarnaOperation(token)
  }

  return (
    <FadeIn>
      <Panel className={styles.container} padding="none m l m">
        <SecondaryAction
          size="large"
          onClick={handleManageCard}
          className={styles.manageCardButton}
        >
          <SettingsIcon className={styles.settingsIcon} />
          <HeadingXSmall Tag="p" left>
            <Label copyKey="omnicredit.card.button.text" />
          </HeadingXSmall>
        </SecondaryAction>
      </Panel>
    </FadeIn>
  )
}

ManageCard.propTypes = {
  manageCardOperation: PropTypes.object,
}

export default ManageCard
